import { MyTrainingsDatatableQuery } from 'generated/resources/datatable.graphql'

import { useDataTable } from 'modules/core/components/DataTable'

export const useMyTrainingDatatable = () => {
  const data = useDataTable<MyTrainingsDatatableQuery>()

  const findTrainingBySessionId = (sessionId: number) => {
    return data.queryResult.data?.trainings.trainingsConnection.edges.find((training) =>
      training.node?.sessions.find((session) => session.id === Number(sessionId))
    )?.node
  }

  const getTrainings = () => {
    return data.queryResult.data?.trainings.trainingsConnection.edges.map(
      (training) => training.node
    )
  }

  return { findTrainingBySessionId, getTrainings }
}
